import { trpc } from 'src/utils/trpc';
import { getIcon, getIconMapName } from 'src/utils/icons';
import { Typography } from 'src/ui/typography';
import { cn } from 'src/utils/@/lib/utils';

const CarketaConnect = (vehicle: any) => {
  const { data: recon_workflow } =
    trpc.vehicle_recon.getConnectWorkflowRecon.useQuery(
      { vehicle_id: vehicle?.vehicle?.id },
      {
        refetchOnWindowFocus: true,
        enabled: !!vehicle,
      }
    );

  const CircleIcon = getIcon('Circle');

  return (
    <>
      <Typography variant="h6" className="mb-10 mt-10 text-black">
        Carketa Connect
      </Typography>

      <div className="flex justify-between mb-4 flex-col">
        <p className="text-16 ">
          {vehicle?.vehicle?.year} {vehicle?.vehicle?.make}{' '}
          {vehicle?.vehicle?.model} {vehicle?.vehicle?.trim}
        </p>
      </div>
      <div className="flex">
        <p className="text-14 mr-4 ">VIN</p>
        <p className="text-14 gray-500">{vehicle?.vehicle?.vin}</p>
      </div>
      <div className="flex mb-10">
        <p className="text-14 mr-4 ">STOCK#</p>
        <p className="text-14 gray-500">{vehicle?.vehicle?.stock_number}</p>
      </div>

      <div className="p-2 w-full outline outline-1 outline-[#bdbdbd] rounded">
        <div className="py-2 px-4 ">
          <Typography
            variant="subtitle1"
            className="mb-10 ml-4 mt-10 text-black"
          >
            Recon Progress
          </Typography>
          <div className="stepper">
            <ol className="stepper__content">
              {recon_workflow?.map((step, index) => {
                const { id, status, title, icon } = step;
                const Icon = getIcon(getIconMapName(icon ?? 'InsertPhoto'));
                if (status === 'Completed') {
                  return (
                    <li
                      key={id}
                      className={cn(
                        'relative flex items-center gap-4 pb-6',
                        "before:h-[35px] before:w-[47px] before:shrink-0 before:rounded-full before:bg-contain before:bg-center before:bg-no-repeat before:content-['']",
                        "after:absolute after:top-[35px] after:bottom-0 after:w-[3px] after:translate-x-[22.5px] after:bg-[#a3a1a6] after:content-['']",
                        'last:after:hidden'
                      )}
                    >
                      <div className="absolute left-1.5 top-0 rounded-full border border-solid p-1 text-primary">
                        <Icon className="h-6 w-6" />
                      </div>
                      <div>
                        <h3 className="stepper__title">{`Completed ${
                          title ?? 'Step ' + (index + 1)
                        }`}</h3>
                      </div>
                    </li>
                  );
                } else {
                  return (
                    <li
                      key={id}
                      className={cn(
                        'relative flex items-center gap-4 pb-6',
                        "before:h-5 before:w-[47px] before:shrink-0 before:rounded-full before:bg-contain before:bg-center before:bg-no-repeat before:content-['']",
                        "after:absolute after:top-[26px] after:-bottom-px after:w-[3px] after:translate-x-[22.5px] after:bg-[#a3a1a6] after:content-['']",
                        'last:after:hidden'
                      )}
                    >
                      <div className="absolute left-3.5 top-0 text-secondary">
                        <CircleIcon className="h-4 w-4" />
                      </div>
                      <div>
                        <h3 className="stepper__subtitle">{`Waiting ${
                          title ?? 'Step ' + (index + 1)
                        }`}</h3>
                      </div>
                    </li>
                  );
                }
              })}
            </ol>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarketaConnect;
